export default "__VITE_ASSET__Bkw4DBnB__"